
import React from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faPhone, faEnvelope, faLocationDot, faHashtag } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import footerBg from "./../../assets/footerbg.jpg";
import img from "./../../assets/sheoran.jpg";
import dummy from "./../../assets/dummy.png";
import img2 from "./../../assets/Sunil.jpg";
import img3 from "./../../assets/Chhawari.jpg";
import img4 from "./../../assets/Sujata.jpg";
import img5 from "./../../assets/Sudhir.jpg";
import img6 from "./../../assets/Sharma.jpg";
import img7 from "./../../assets/Kundu.jpg";
import img8 from "./../../assets/Dhaka.jpg";
import img9 from "./../../assets/Suhag.jpg";
import img10 from "./../../assets/Dalal.jpg";
import img11 from "./../../assets/Sanjay.jpg";


const data = [
  { district: '  Ambala',  profile: 'dswAmbala', officer: 'Col Ajay Kumar Sheoran (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Ambala Cantt.", email:"Zsbambala3@gmail.com, amb.ainikb-hry@gov.in",phone:"8875418547", image:img ,officeNo:"0171-2640557, Rest House 2643951"},

  { district: '  Bhiwani',  profile: 'dswBhiwani', officer: 'Wg Cdr Sunil Kumar (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office, Rly Road, Bhiwani.", email:"zsbbwn@gmail.com",phone:"8958181434", image:dummy ,officeNo:"01664-243538"},

  { district: '  Charkhi Dadri',  profile: 'dswCharkhiDadri', officer: 'Wg Cdr Sunil Kumar (Retd)',address:"Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Charkhi Dadri.", email:"zsbdadri@gmail.com",phone:"8958181434", image:img2 ,officeNo:"1250297835"},

  { district: '  Faridabad',  profile: 'dswFaridabad', officer: 'Capt (IN) Rajneesh S Chhawari (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sector-16, Faridabad", email:"zsbfaridabad@gmail.com",phone:"9425393650", image:img3 ,officeNo:"0129- 4871909"},


  { district: 'Fatehabad',  profile: 'dswFatehabad', officer: 'Wg Cdr Sujata (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, 24-A, Industrial Area, Fatehabad.", email:"fatehabadzsb@gmail.com",phone:"8155957960", image:img4 ,officeNo:"01667-224219"},

  { district: 'Gurugram',  profile: 'dswGurugram', officer: 'Lt. Col Aman Singh Yadav (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office, Opp. Apna Bazar, Civil Lines, Gurgaon.", email:"zsbggn@gmail.com",phone:"9466291521, 9971610700", image:dummy,officeNo:"0124-2320730"},

  { district: 'Hisar',  profile: 'dswHisar', officer: 'Wg Cdr Sujata (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Near Old Court, Hisar.", email:"zsb.hisar@rediffmail.com",phone:"8155957960 ", image:dummy ,officeNo:"01662-272901"},

  { district: '  Jhajjar',  profile: 'dswJhajjar', officer: 'Col Rajeev Kundu (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office c/o Sainik Rest House, Jhajjar, Near Govt. Civil Hospital, Jhajjar, Haryana-124103.", email:"Secy.zsbjjr@yahoo.com, zsbjjr@gmail.com",phone:"8826674899", image:dummy,officeNo:"01251-254236"},

  { district: '  Jind',  profile: 'dswJind', officer: 'Gp Capt Sudhir Nasiar (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Jind", email:"zsbjind@yahoo.com",phone:"7030392957", image:img5,officeNo:"01681-245254"},

  { district: '  Kaithal',  profile: 'dswKaithal', officer: 'Col. Om Parkash Sharma (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, \Bldg No.761/13, Amargarh Gamri, Opp. Gali No.-3, Kaithal", email:"secretaryzsbktl@gmail.com",phone:"09436194087", image:img6 ,officeNo:"01746-223731"},

  { district: '  Karnal',  profile: 'dswKarnal', officer: 'Col. Om Parkash Sharma (Retd.)',address:"District Sainik and Ardh Sainik Welfare Office, Near Distt. Session Court- Old GT Road, Karnal.", email:"secretaryzsbknl@gmail.com",phone:"09436194087", image:img6 ,officeNo:"0184-2272589"},

  { district: '  Kurukshetra',  profile: 'dswKurukshetra', officer: 'Col. Ajay Kumar Sheoran (Retd) ',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House Complex, Kurukshetra.", email:"zsbkkr@gmail.com",phone:"8875418547", image:dummy ,officeNo:"01744-220922"},


  { district: '  Narnaul',  profile: 'dswNarnaul', officer: 'Wg Cdr Satish Chander Yadav (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Near Bus Stand, Narnaul.", email:"zsb_nnl@yahoo.com",phone:"9654374712", image:dummy ,officeNo:"01282-250259"},

  { district: '  Nuh',  profile: 'dswNuh', officer: 'Col Davinder Singh Dhaka (Retd)' ,address:"Ward No.-5, Near Bijli Board, Nuh – 122107", email:"zsbggn@gmail.com",phone:"9953761992", image:dummy,officeNo:"0124-2320730"},

  { district: '  Palwal',  profile: 'dswPalwal', officer: 'Col Davinder Singh Dhaka (Retd)',address:"Old SDM Court Complex, NH-2, Palwal – 121102.", email:"palwalzsb@gmail.com",phone:"9953761992", image:img8 ,officeNo:"01275-297790"},

  { district: '  Panchkula',  profile: 'dswPanchkula', officer: 'Wg Cdr Sanjay Kumar Rai (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, 227, B Block, Yojna Bhawan, Sec-04, Panchkula.", email:"zsbpkl@yahoo.com",phone:"8126442556 ", image:dummy ,officeNo:"0172-2584213"},

  { district: '  Panipat',  profile: 'dswPanipat', officer: 'Col Rajeev Kundu (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Kothi No.118, Adarsh Nagar, Near Post Office, CSD Canteen, Panipat.", email:"pnpzsb@gmail.com",phone:"8826674899", image:dummy ,officeNo:"0180-2650311"},

  { district: '  Rewari',  profile: 'dswRewari', officer: 'Lt. Col Aman Singh Yadav (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Rewari", email:"zsbrwr@gmail.com",phone:"9466291521, 971610700 ", image:dummy ,officeNo:"01274-224341"},

  { district: '  Rohtak',  profile: 'dswRohtak', officer: 'Wg Cdr Gaurika Suhag (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Civil Road, Near Chhotu Ram Park, Rohtak.", email:"zsbrohtak@gmail.com",phone:"8168588014", image:img9 ,officeNo:"01262-230687"},

  { district: '  Sirsa',  profile: 'dswSirsa', officer: 'Col Kuldeep Singh Dalal (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Barnala Road, Near Police Lines, Sirsa.", email:"zsbsrs@gmail.com",phone:"9868154386", image:dummy ,officeNo:"01666-297545"},

  { district: '  Sonipat',  profile: 'dswSonipat', officer: 'Col Kuldeep Singh Dalal (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Gohana Road, Near Police Lines, Sonipat.", email:"zsbspt@gmail.com",phone:"986815438", image:img10 ,officeNo:"0130-2220659"},

  { district: '  Yamuna Nagar',  profile: 'dswYamunaNagar', officer: 'Wg Cdr Sanjay Kumar Rai (Retd) ',address:"Sainik and Ardh Sainik Welfare Office, Near Panchayat Bhawan, Yamuna Nagar", email:"zsbynr@yahoo.com",phone:"8126442556", image:img11 ,officeNo:"01732-211892"},
];
const ContactUs = () => {

   return (
     <>
       {/* Header Section - Matching WhoWho Theme */}
       <div style={{
         backgroundImage: `url(${footerBg})`,
         backgroundSize: 'cover',
         backgroundPosition: 'center',
         padding: '30px 0',
         color: 'white',
         margin:'2%',
         borderRadius:'10px'
       }}>
         <Container>
           <h3 className="fw-bold mb-0 text-center">
             <FontAwesomeIcon icon={faAddressBook} className="me-2" />
             Contact Us
           </h3>
         </Container>
       </div>

       <div className="container-fluid px-5 mb-3">
         <section className="content pb-3" style={{ textAlign: "justify" }}>
           <div className="table-responsive" style={{ borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}>
             <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: '0', background: 'white' }}>
               <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                 <tr style={{ 
                   background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                   color: 'white'
                 }}>
                   <th style={{ border: "none", padding: "18px 15px", fontWeight: '600', fontSize: '0.95rem', textAlign: 'center' }}>
                     Sr. No.
                   </th>
                   <th style={{ border: "none", padding: "18px 15px", fontWeight: '600', fontSize: '0.95rem' }}>
                     District
                   </th>
                   <th style={{ border: "none", padding: "18px 15px", fontWeight: '600', fontSize: '0.95rem' }}>
                     <FontAwesomeIcon icon={faLocationDot} className="me-2" />Office Address
                   </th>
                   <th style={{ border: "none", padding: "18px 15px", fontWeight: '600', fontSize: '0.95rem' }}>
                     <FontAwesomeIcon icon={faPhone} className="me-2" />Contact Number
                   </th>
                   <th style={{ border: "none", padding: "18px 15px", fontWeight: '600', fontSize: '0.95rem' }}>
                     <FontAwesomeIcon icon={faEnvelope} className="me-2" />Email
                   </th>
                 </tr>
               </thead>
               <tbody>
                 {data.map((item, index) => (
                   <tr key={index} 
                     style={{ 
                       backgroundColor: 'white',
                       transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                       borderLeft: '4px solid transparent'
                     }}
                     onMouseEnter={(e) => {
                       e.currentTarget.style.backgroundColor = '#f0f4ff';
                       e.currentTarget.style.borderLeft = `4px solid ${index % 3 === 0 ? '#1e3c72' : index % 3 === 1 ? '#16a085' : '#8e44ad'}`;
                       e.currentTarget.style.transform = 'scale(1.005)';
                       e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                       e.currentTarget.style.zIndex = '1';
                       e.currentTarget.style.position = 'relative';
                     }}
                     onMouseLeave={(e) => {
                       e.currentTarget.style.backgroundColor = 'white';
                       e.currentTarget.style.borderLeft = '4px solid transparent';
                       e.currentTarget.style.transform = 'scale(1)';
                       e.currentTarget.style.boxShadow = 'none';
                       e.currentTarget.style.zIndex = '0';
                     }}
                   >
                     <td style={{ 
                       border: "none",
                       borderBottom: "1px solid #e9ecef", 
                       padding: "16px 15px",
                       textAlign: 'center'
                     }}>
                       <span >
                         {index + 1}
                       </span>
                     </td>
                     <td style={{ 
                       border: "none",
                       borderBottom: "1px solid #e9ecef", 
                       padding: "16px 15px",
                       color: '#1e3c72',
                       fontWeight: '600',
                       fontSize: '0.95rem',
                       whiteSpace: 'nowrap'
                     }}>
                       <span style={{
                         display: 'flex',
                         alignItems: 'center'
                       }}>
                       {item.district}
                       </span>
                     </td>
                     <td style={{ 
                       border: "none",
                       borderBottom: "1px solid #e9ecef", 
                       padding: "16px 15px",
                       color: '#495057',
                       fontSize: '0.9rem',
                       lineHeight: '1.5'
                     }}>
                       {item.address}
                     </td>
                     <td style={{ 
                       border: "none",
                       borderBottom: "1px solid #e9ecef", 
                       padding: "16px 15px"
                     }}>
                       <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                         {item.officeNo.split(',').map((phone, idx) => (
                           <span key={idx} style={{
                             color: '#16a085',
                             fontWeight: '600',
                             fontSize: '0.85rem',
                             background: 'rgba(22, 160, 133, 0.1)',
                             padding: '5px 10px',
                             borderRadius: '6px',
                             display: 'inline-flex',
                             alignItems: 'center',
                             whiteSpace: 'nowrap'
                           }}>
                             <FontAwesomeIcon icon={faPhone} className="me-1" style={{fontSize: '0.75rem'}} />
                             {phone.trim()}
                           </span>
                         ))}
                       </div>
                     </td>
                     <td style={{ 
                       border: "none",
                       borderBottom: "1px solid #e9ecef", 
                       padding: "16px 15px",
                       color: '#2c3e50',
                       fontSize: '0.9rem'
                     }}>
                       <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                         {item.email.split(',').map((email, idx) => (
                           <span key={idx} style={{
                             background: 'rgba(30, 60, 114, 0.08)',
                             padding: '5px 10px',
                             borderRadius: '6px',
                             display: 'inline-flex',
                             alignItems: 'center',
                             fontSize: '0.85rem'
                           }}>
                             <FontAwesomeIcon icon={faEnvelope} className="me-1" style={{color: '#1e3c72', fontSize: '0.75rem'}} />
                             {email.trim()}
                           </span>
                         ))}
                       </div>
                     </td>
                   </tr>
                 ))}
               </tbody>
             </table>
           </div>
         </section>
        
       </div>
     </>
  );
};

export default ContactUs;
